import React, { useEffect, useState } from 'react'
import firebase from 'firebase'
import { base } from '../fire'
import { Switch } from "@blueprintjs/core";

const Users = () => {

    const [userList, setUserList] = useState([1, 2, 3, 4])
    const [isLoading, setIsLoading] = useState(true)

    const getUsers = async () => {
        try {
            let users
            var ref = firebase.database().ref(`users`);
            ref.on('value', function (snapshot) {
                users = snapshot.val()
                const usersArray = Object.entries(users).map((e) => ({ [e[0]]: e[1] }));
                setUserList(usersArray)
                setIsLoading(false)
            });
        } catch (error) {
            console.log(error)
        }
    }

    const toggleIsAllowed = (id, userInfo, isNotAllowed) => {
        if ((isNotAllowed === undefined || isNotAllowed === false)) {
            base.update(`/users/${id}`, {
                data: { ...userInfo, isNotAllowed: true }
            });
        } else {
            console.log('isnotAllowed')
            base.update(`/users/${id}`, {
                data: { ...userInfo, isNotAllowed: false }
            })
        }
    }

    useEffect(() => {
        getUsers();
    }, [])

    if (isLoading) return <h3 className="text-center">Loading...</h3>

    return (
        <div>
            <br /><br />
            <table className="bp3-html-table full-width">
                <thead className='d-none-mob'>
                    <tr>
                        <th>Name / Surname</th>
                        <th>Email</th>
                        <th>Company</th>
                        <th>Activity</th>
                        <th>Is approved</th>
                    </tr>
                </thead>
                <tbody>
                    {userList.map((user, index) => {
                        const userInfo = user[Object.keys(user)[0]]
                        const id = Object.keys(user)[0]
                        if (id === "S86sotaTDUN9yS5IsgB5ngrIoj72") {
                            return <tr key={index}></tr>
                        } else {
                            return (
                                <tr className='block-session' key={index} >
                                    <td className='d-none-comp'>Nom de la session</td>
                                    <td>
                                        {userInfo.firstname} {userInfo.lastname}
                                    </td>
                                    <td>
                                        {userInfo.email ? userInfo.email : '-'}
                                    </td>
                                    <td>
                                        {userInfo.company}
                                    </td>
                                    <td>
                                        {userInfo.activity}
                                    </td>
                                    <td>
                                        <Switch checked={(!userInfo.isNotAllowed)} label="Approved" onChange={() => toggleIsAllowed(id, userInfo, userInfo.isNotAllowed)} />
                                    </td>
                                </tr>
                            )
                        }
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default Users
